module.exports = __webpack_public_path__ + "static/media/ellie_2.3682d7ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/MoreWork/assets/ellie_2.png
// module id = 486
// module chunks = 0